<template>
  <component :is="tag">
    <div ref="$video">
      <slot name="video" />
    </div>
    <slot
      v-if="!played"
      :play="play"
    />
  </component>
</template>

<script>
import Plyr from 'plyr'

export default {
  props: {
    tag: {
      type: String,
      default: 'div',
    },
  },
  data() {
    return {
      plyr: undefined,
      played: false,
    }
  },
  mounted() {
    this.plyr = new Plyr(this.$refs.$video)
  },
  methods: {
    play() {
      this.played = true
      this.plyr.play()
    }
  }
}
</script>
